// React
import React, { useState } from 'react';

// Prop types
import PropTypes from 'prop-types';

// Component
import SerivceName from './SerivceName';
import MemoCard from './MemoCard';
import MemoTable from './MemoTable';

// Mui styles
import { withStyles } from '@material-ui/core/styles';

// Mui core
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';

// Icon
import SearchIcon from '@material-ui/icons/Search';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';

const styles = (theme) =>
	({
		root : {
			height               : 'calc(100% - 100px)',
			aspectRatio          : 1.777,
			maxWidth             : '98vw',
			minWidth             : 800,
			backgroundColor      : '#e5e5e2',
			backgroundAttachment : 'fixed',
			backgroundPosition   : 'center',
			backgroundSize       : 'cover',
			backgroundRepeat     : 'no-repeat',
			borderRadius         : '20px',
			padding              : '1%',
			flexDirection        : 'column',
			zIndex               : 1,
			overflow             : 'auto'
		},
		header : {
			display    : 'flex',
			position   : 'relative',
			alignItems : 'center'
		},
		logo : {
			width        : 'auto',
			height       : '2.5rem',
			position     : 'absolute',
			marginBottom : '1%'
		},
		search : {
			width                          : '100%',
			display                        : 'flex',
			flexDirection                  : 'row',
			padding                        : '1rem 0',
			justifyContent                 : 'center',
			[theme.breakpoints.down('xs')] :
			{
				alignItems : 'center'
			}
		},
		searchArea : {
			width   : '26%',
			display : 'grid'
		},
		searchGroup : {
			color                          : '#878686',
			fontSize                       : '0.9rem',
			display                        : 'flex',
			alignItems                     : 'center',
			justifyContent                 : 'space-between',
			[theme.breakpoints.down('xs')] :
			{
				padding : '0.5rem 0'
			}
		},
		searchInput : {
			background   : '#999898',
			padding      : '0.5rem 0.7rem',
			borderRadius : '0.5rem',
			color        : 'white',
			textAlign    : 'left',
			border       : 'none',
			width        : '70%',
			marginRight  : '1rem',
			'&:focus'    : {
				outline : 'none'
			}
		},
		searchBtn : {
			width           : '4rem',
			height          : '4rem',
			borderRadius    : '4rem',
			fontSize        : '0.6rem',
			backgroundColor : '#9ec317',
			color           : 'white',
			boxShadow       : '2px 2px 4px inset #aaa',
			justifyContent  : 'center',
			alignItems      : 'center',
			display         : 'grid',
			lineHeight      : 1.5,
			whiteSpace      : 'nowrap',
			margin          : '0.5rem 0',
			'&:hover'       : {
				backgroundColor : '#f50057'
			}
		},
		searchIcon : {
			width  : '2rem',
			height : '2rem'
		},
		searchResult : {
			width          : '100%',
			height         : 'calc(99% - 9.5rem)',
			display        : 'flex',
			justifyContent : 'center'
		},
		tableArea : {
			width  : '60%',
			height : '100%'
		},
		arrow : {
			width          : '3rem',
			height         : '100%',
			display        : 'flex',
			alignItems     : 'center',
			justifyContent : 'center'
		},
		arrowIcon : {
			width     : '3rem',
			height    : '3rem',
			marginTop : '3rem',
			color     : '#999898'
		},
		cardArea : {
			width         : '40%',
			height        : '100%',
			display       : 'flex',
			flexDirection : 'column',
			background    : 'transparent'
		},
		cardBg : {
			marginTop : '3rem',
			height    : 'calc(94% - 3rem)'
		}
	});

const MemoPage = ({
	classes
}) =>
{
	const [ memo, setMemo ] = useState(null);
	const [ query, setQuery ] = useState({ name: '', sms: '', message: '', date: null });

	const [ name, setName ] = useState('');
	const [ sms, setSMS ] = useState('');
	const [ message, setMessage ] = useState('');
	const [ date, setDate ] = useState('');

	const handleChangeName = (e) =>
	{
		setName(e.target.value);
	};

	const handleChangeSMS = (e) =>
	{
		const numberPattern = /^[0-9]*$/;

		if (numberPattern.test(e.target.value))
		{
			setSMS(e.target.value);
		}
	};

	const handleChangeMessage = (e) =>
	{
		setMessage(e.target.value);
	};

	const handleChangeDate = (e) =>
	{
		setDate(e.target.value);
	};

	const onMemoSelected = (item) =>
	{
		setMemo(item);
	};

	const search = () =>
	{
		setQuery({
			name    : name,
			sms     : sms,
			message : message,
			date    : date,
			email   : ''
		});
	};

	return (
		<Box className={classes.root}>
			<Box className={classes.header}>
				<SerivceName />
			</Box>
			<Box className={classes.search}>
				<Box className={classes.searchArea}>
					<Box className={classes.searchGroup}>
						<p>名　前</p>
						<input
							type='text'
							value={name}
							className={classes.searchInput}
							onChange={(value) => handleChangeName(value)}
						/>
					</Box>
					<Box className={classes.searchGroup}>
						<p>連絡先</p>
						<input
							type='text'
							value={sms}
							className={classes.searchInput}
							onChange={(value) => handleChangeSMS(value)}
						/>
					</Box>
				</Box>
				<Box className={classes.searchArea}>
					<Box className={classes.searchGroup}>
						<p>日　付</p>
						<input
							type='date'
							value={date}
							className={classes.searchInput}
							onChange={(value) => handleChangeDate(value)}
						/>
					</Box>
					<Box className={classes.searchGroup}>
						<p>キーワード</p>
						<input
							type='text'
							value={message}
							className={classes.searchInput}
							onChange={(value) => handleChangeMessage(value)}
						/>
					</Box>
				</Box>
				<Button className={classes.searchBtn} onClick={search}>
					<SearchIcon className={classes.searchIcon} />
					<p>検　索</p>
				</Button>
			</Box>
			<Box className={classes.searchResult}>
				<Box className={classes.tableArea}>
					<MemoTable onSelect={onMemoSelected} queryObj={query}/>
				</Box>
				<Box className={classes.arrow}>
					<PlayArrowIcon className={classes.arrowIcon} />
				</Box>
				<Box className={classes.cardArea}>
					<Box className={classes.cardBg}>
						{(memo !== null) &&
						<MemoCard memo={memo}/>
						}
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

MemoPage.propTypes =
{
	classes : PropTypes.object.isRequired
};

export default withStyles(styles)(MemoPage);